import { find, select } from './generic';
import { couponsFields, couponsTable, ratesFields, ratesTable, shippingFields, shippingTable, stripeFields, stripeTable, textsFields, textsTable, uiFields, uiTable } from './metadata/settings';
import { userFields } from './metadata/users';

export const couponsOptions = {
  fields: couponsFields,
  managedFields: [],
  route: `/airtable/Settings/${couponsTable}`,
  table: couponsTable,
  map: record => {
    return {
      code: record[couponsFields.CODE],
      enabled: record[couponsFields.ENABLED],
      type: record[couponsFields.TYPE],
      xValue: record[couponsFields.XVALUE],
      yValue: record[couponsFields.YVALUE],
    };
  },
  transform: record => {
    return {
      ...record,
      [couponsFields.NAME]: record[couponsFields.NAME].toLowerCase(),
    };
  },
};

export const ratesOptions = {
  fields: ratesFields,
  managedFields: [],
  route: `/airtable/Settings/${ratesTable}`,
  table: ratesTable,
};

export const shippingOptions = {
  fields: shippingFields,
  managedFields: [],
  route: `/airtable/Settings/${shippingTable}`,
  table: shippingTable,
  map: record => {
    return {
      enabled: record[shippingFields.ENABLED],
      rate: record[shippingFields.RATE],
      type: record[shippingFields.TYPE],
      xValue: record[shippingFields.XVALUE],
      yValue: record[shippingFields.YVALUE],
    };
  },
};

export const stripeOptions = {
  fields: stripeFields,
  table: stripeTable,
};

export const textsOptions = {
  fields: textsFields,
  managedFields: [],
  route: `/airtable/Settings/${textsTable}`,
};

export const uiOptions = {
  managedFields: [],
  route: `/airtable/Settings/${uiTable}`,
};

async function fetchCoupons() {
  return fetchSettingsMapOf(couponsOptions);
}

function fetchRates() {
  return fetchSettingsMapOf(ratesOptions);
}

function fetchShipping() {
  return fetchSettingsMapOf(shippingOptions);
}

function fetchTexts() {
  return fetchSettingsMapOf(textsOptions);
}

async function fetchUI(user) {
  const userID = user?.airtable?.fields[userFields.USER_ID];

  if (userID) {
    const filter = `{${uiFields.USER_ID}} = ${userID}`;

    const [settings] = await find(uiOptions, filter);
    const fields = settings?.fields ?? {};

    return {
      showMetronicStuff: fields['Show Metronic stuff'],
    };
  }

  return {
    showMetronicStuff: false,
  };
}

async function fetchSettingsMapOf(options) {
  const records = await select(options);
  return makeSettingsMapOf(records, options);
}

function makeSettingsMapOf(records, options) {
  const settings = new Map();

  for (const record of records) {
    const transformedFields = options.transform
      ? options.transform(record.fields)
      : record.fields;

    const {
      [options.fields.NAME]: key,
    } = transformedFields;

    if (typeof options.map === 'function') {
      settings.set(key, options.map(transformedFields));
    } else {
      const {
        [options.fields.NAME]: key,
        [options.fields.VALUE]: value = '',
      } = transformedFields;

      settings.set(key, value);
    }
  }

  return settings;
}

export {
  fetchCoupons,
  fetchRates,
  fetchShipping,
  fetchTexts,
  fetchUI,
  makeSettingsMapOf,
};
